import React                        from 'react';
import ApprovedUsersForm            from '../components/forms/ApprovedUsersForm';
import Loader                       from '../components/Loader';
import SuccessPage                  from './SuccessPage';

import { connect }                  from 'react-redux';
import { Dispatch }                 from "redux";

import submitApprovedUser           from '../utils/submit_approved_user';

import { initialApprovedUserState } from '../utils/initial_states';
import useGetOrgName                from 'functions/get_org_name';




import { 
    RESET,
    SUBMIT_APPROVED_USER_FORM_SAGA,
}                                   from '../actions'
import { 
    ActionTypes, 
    submitApprovedUserFormType,
}                            from '../actions/types'

import { reducerType }       from '../reducer';

import { makeStyles }        from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root : {
        position:        'fixed',
        left:            0,
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column',
        backgroundColor: '#FFF',
        overflowY:       'scroll',
        overflowX:       'hidden',
    },
    loading: {
        margin:   20,
        fontSize: 20,
    }
}))

type RootPropsType = {
    actionInit:             boolean;
    actionComplete:         boolean;
    showError:              boolean;
    showLoader:             boolean;
    submitApprovedUserForm: (payload: submitApprovedUserFormType) => void;
    reset:                  () => void;
}

const Root: React.FC<RootPropsType> = ({ 
    actionInit,
    actionComplete,
    showError,
    showLoader,
    submitApprovedUserForm,
    reset
 }) => {


    const classes = useStyles();

    const [size, setSize] = React.useState([0,0]);
  
    React.useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);


    const [approvedUserState, setApprovedUserState] = React.useState(initialApprovedUserState)
    const [error, setError]                         = React.useState('')


    useGetOrgName(setApprovedUserState);

    return(
        <div className = { classes.root }>
            {
                !actionInit && !actionComplete
                &&
                <ApprovedUsersForm
                   size           = { size }
                   state          = { approvedUserState }
                   error          = { error }
                   showError      = { showError }
                   setState       = { setApprovedUserState }
                   handleSubmit   = { () => {  submitApprovedUser(approvedUserState, error, setError, submitApprovedUserForm) } }
               />
            }
            {
                actionComplete
                &&
                <SuccessPage reset = { reset }/>
            }
            {
                actionInit
                &&
                <div className = { classes.root } >
                  <div className = { classes.loading }>אנא המתן</div>
                  <Loader/>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (reducer: reducerType) => {

    return {
        actionInit:     reducer.actionInit,
        actionComplete: reducer.actionComplete,
        showError:      reducer.showError,
        showLoader:     reducer.showLoader,
    }
  };
  

  const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
    submitApprovedUserForm: (payload: submitApprovedUserFormType) => dispatch(SUBMIT_APPROVED_USER_FORM_SAGA(payload)),
    reset:                  () => dispatch(RESET())
});
  
  export default connect(mapStateToProps, mapDispatchToProps)(Root);

  
